import Axios from "axios";
import {
    SET_SALES_PRODUCT_BASED_COMMISSION_LIST,
    UNSET_SALES_PRODUCT_BASED_COMMISSION_LIST,
    SET_EDITING_SALES_PRODUCT_BASED_COMMISSION,
    UNSET_EDITING_SALES_PRODUCT_BASED_COMMISSION
} from "@/store/mutation-types";
import { saveUpdateProductBasedCommission, getSalesProductBasedCommissionList, getSalesProductBasedCommissionById } from "@/store/api";

const state = {
    getSalesProductBasedCommissionList: [],
    editingSalesProductBasedCommission: null,
};

const getters = {
    getSalesProductBasedCommissionList(state) {
        return state.getSalesProductBasedCommissionList;
    },
    getEditingSalesProductBasedCommission(state) {
        return state.editingSalesProductBasedCommission;
    }
};

const mutations = {
    [SET_SALES_PRODUCT_BASED_COMMISSION_LIST](state, data) {
        state.getSalesProductBasedCommissionList = data;
    },
    [UNSET_SALES_PRODUCT_BASED_COMMISSION_LIST](state) {
        state.getSalesProductBasedCommissionList = [];
    },
    [SET_EDITING_SALES_PRODUCT_BASED_COMMISSION](state, data) {
        state.editingSalesProductBasedCommission = data;
    },
    [UNSET_EDITING_SALES_PRODUCT_BASED_COMMISSION](state) {
        state.editingSalesProductBasedCommission = [];
    }
};

const actions = {
    saveUpdateProductBasedCommission({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateProductBasedCommission, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesProductBasedCommissionList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesProductBasedCommissionList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_PRODUCT_BASED_COMMISSION_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_PRODUCT_BASED_COMMISSION_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleProductBasedCommissionById({ commit }, data) {
        const getSaleProductBasedCommission = `${getSalesProductBasedCommissionById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleProductBasedCommission)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
